/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Posts_Create_TitleInputs */

const en_admin_posts_create_title = /** @type {(inputs: Admin_Posts_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create New Post`)
};

const zh_admin_posts_create_title = /** @type {(inputs: Admin_Posts_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建新文章`)
};

/**
* | output |
* | --- |
* | "Create New Post" |
*
* @param {Admin_Posts_Create_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_posts_create_title = /** @type {((inputs?: Admin_Posts_Create_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Posts_Create_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_posts_create_title(inputs)
	return zh_admin_posts_create_title(inputs)
});
export { admin_posts_create_title as "admin.posts.create_title" }